<template>
  <div class="order-page">
    <top-bar :topbarList="orderTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { mapState } from "vuex";

import { orderIndexMixins } from "@/mixins/orderIndexMixins";

export default {
  mixins: [orderIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.order-page {
  height: 100%;
}
</style>

<style lang="less">
.order-page {
  .alignCenter {
    display: flex;
    align-items: center;
  }

  .column {
    display: flex;
    flex-direction: column;
  }
  .justCenter {
    display: flex;
    justify-content: center;
  }
}
.td td,
.th td {
  vertical-align: middle;
}
</style>
